import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from '../../shared/services/common.service';
import { Account } from '../../shared/models';

@Component({
    selector: 'app-portal',
    templateUrl: './portal.component.html',
    styleUrls: ['./portal.component.scss'],
    standalone: false
})
export class PortalComponent implements OnInit, OnDestroy {
  isFullScreen = false;
  makeBackgroundWhite = false;
  public account: Account;
  @ViewChild('scrollContainer', { static: false }) scrollContainer: ElementRef;
  private readonly onDestroy: Subject<any> = new Subject<any>();
  private scrollThreshold = 200; // Pixels to scroll before changing header

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
  ) {
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.checkScrollPosition();
  }

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        this.isFullScreen = !!qp.fs;
      });

    this.commonService.setHeaderBgWhite
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.makeBackgroundWhite = !!data;
      });

    // Check initial scroll position
    setTimeout(() => this.checkScrollPosition(), 100);
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

  private checkScrollPosition(): void {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollPosition > this.scrollThreshold) {
      this.commonService.setHeaderBgWhite.next(true);
    } else if (scrollPosition === 0) {
      this.commonService.setHeaderBgWhite.next(false);
    }
  }
}
